const themes = {
    Default:'default',
    Contrast:'contrast'
}


export default themes;